// $(document).ready(function () {
	$(".js-sourcetoggle").click(function (event) {
		$(this).parent(".kreon-source").toggleClass('open');
		// $(this).toggleClass('kreon-capsule');
		// $('.kreon *:not(.kreon-source)').click( function(event2) {
		// 	if ($(this).hasClass('slider')) {
		// 		$('.kreon-source').toggleClass('open');
		// 		$(this).unbind('click');
		// 	}
		// });
	});

	$(".js-sourcetoggle").click(function (event) {
		$(this).parent(".pill-source").toggleClass('open');
		// $(this).toggleClass('another-pill');
		// $('.pill *:not(.pill-source)').click( function(event2) {
		// 	if ($(this).hasClass('slider')) {
		// 		$('.pill-source').toggleClass('open');
		// 		$(this).unbind('click');
		// 	}
		// });
	});

$(".js-sourcetoggle").click(function (event) {
	$(this).parent(".capsule-source").toggleClass('open');
	// $(this).toggleClass('another-pill');
	// $('.pill *:not(.pill-source)').click( function(event2) {
	// 	if ($(this).hasClass('slider')) {
	// 		$('.pill-source').toggleClass('open');
	// 		$(this).unbind('click');
	// 	}
	// });
});

	setFontSize();

    $(window).resize(function () {
		setFontSize()
    });

    function setFontSizeDesktop() {
        let width = $(window).width();
        let height = $(window).height();

        let fs1 = width / 85.375;
        let fs2 = height / 50.625;

        if (fs1 > fs2) {
            $(".kreon").css("font-size", fs2);
        } else {
            $(".kreon").css("font-size", fs1);
		}

		if (fs1 > fs2) {
            $(".pill").css("font-size", fs2);
        } else {
            $(".pill").css("font-size", fs1);
        }
    }

    function setFontSizeMob() {
        let width = $(window).width();
        let height = $(window).height();

        let fs1 = width / 46.875;
        let fs2 = height / 88;

        if (fs1 > fs2) {
            $(".kreon").css("font-size", fs2);
        } else {
            $(".kreon").css("font-size", fs1);
		}

		if (fs1 > fs2) {
            $(".pill").css("font-size", fs2);
        } else {
            $(".pill").css("font-size", fs1);
        }
    }

    function setFontSize() {
        let windowWidth = $(window).width();
        if (windowWidth > 750) {
			setFontSizeDesktop()
        } else {
			setFontSizeMob();
            $('.step1-slider').slick({
				infinite: false,
				slidesToShow: 1,
				slidesToScroll: 1,
				dots: true,
			});
        }
    }

    function openSlide(id) {
        hideSlides();

        $("[data-slider] .slider-item").eq(id).addClass('active');
    }

    function hideSlides() {
        $("[data-slider] .slider-item").removeClass('active');
    }

    $(window).keypress((e) => {
        if (e.keyCode === 0 || e.keyCode === 32) {
            e.preventDefault();
            let id = $("[data-slider] .slider-item.active").index();
            openSlide(id - 1);
        }
    })
// });
